export default "__VITE_ASSET__64d34ee8__"